import { useNavigate, useSearch } from '@tanstack/react-router';

import { translate } from '../../../common/helpers/translate.helper';
import { DebouncedSearchTextInput } from '../../../common/Search/DebouncedSearchTextInput/DebouncedSearchTextInput';
import { Box } from '../../../common/ui/Box';

export const CustomerGroupSearch = () => {
    const search = useSearch({ from: '/_app/customer-groups/' });
    const navigate = useNavigate({ from: '/customer-groups' });

    const handleChange = (newValue: string) => {
        navigate({ search: { searchQuery: newValue, page: 0 } });
    };

    return (
        <Box width="300px">
            <DebouncedSearchTextInput
                onChange={handleChange}
                value={search.searchQuery}
                placeholder={translate('customergroups.searchForCustomerGroup')}
            />
        </Box>
    );
};
